export const API = "https://tripli-backend.onrender.com";
